import { createAsyncThunk } from '@reduxjs/toolkit';
import { initiateInvoicePayment } from '../services/initiateInvoicePayment.service';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const initiateInvoicePaymentThunk = createAsyncThunk(
  'payments/initiateInvoicePayment',
  async ({ projectId, invoiceId }, { getState, rejectWithValue }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    try {
      return await initiateInvoicePayment(
        projectId,
        invoiceId,
        activeEmployerInfo
      );
    } catch (error) {
      // The server explains why an invoice cannot be paid — unapproved, missing
      // IBAN, already being paid. Those messages are worth showing verbatim
      // rather than replacing with a generic failure.
      // Koa's ctx.throw sends its reason as a plain-text body, so the real
      // explanation ("The invoice total must be...") lives in data itself, not
      // in data.message.
      const data = error?.response?.data;
      return rejectWithValue({
        status: error?.response?.status,
        message:
          (typeof data === 'string' && data) ||
          data?.message ||
          error?.message,
      });
    }
  }
);
